import { render, staticRenderFns } from "./CreateProjectDialog.vue?vue&type=template&id=7411b21a&scoped=true&"
import script from "./CreateProjectDialog.vue?vue&type=script&lang=ts&"
export * from "./CreateProjectDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7411b21a",
  null
  
)

export default component.exports